import { useAppSelector } from '../reducers';
import { useSkuAdditionalUnits } from '../components/merch-card/useSkuAdditionalUnits';
import { calculatedPriceSelector } from '../selectors/PricingSelectors';
import { checkoutProductConfigurationsSelector, productVersionConfigsWithUnitsSelector } from '../selectors/ProductConfigsSelectors';
import { getProductLevelFromApiNameString, getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
export const useProductConfigurationsFromProductLineAndLevel = ({
  productLevel,
  productLine
}) => {
  const {
    additionalUnitSkuId,
    additionalUnitQuantity,
    skuId
  } = useSkuAdditionalUnits({
    productLevel,
    productLine
  });
  const productConfigurations = useAppSelector(state => checkoutProductConfigurationsSelector(state, {
    productConfigurations: productVersionConfigsWithUnitsSelector(state, {
      skuId,
      additionalUnitSkuId: additionalUnitSkuId || undefined,
      additionalUnitQuantity
    }),
    subtractOwnedUnitsIfBuyingNoAdditional: true,
    subtractOwnedSeats: true
  }));
  if (productConfigurations) {
    return productConfigurations;
  } else {
    return [];
  }
};
export const useProductConfigurationsFromApiName = apiName => {
  const productLine = getProductLineFromApiNameString(apiName);
  const productLevel = getProductLevelFromApiNameString(apiName);
  return useProductConfigurationsFromProductLineAndLevel({
    productLine,
    productLevel
  });
};
export const usePricingInfoFromProductConfigurations = productConfigurations => {
  const pricingInfo = useAppSelector(state => {
    return calculatedPriceSelector(state, {
      productConfigurations,
      queryParamTerm: 'annual'
    });
  });
  return pricingInfo;
};
export const usePricingInfoFromApiName = apiName => {
  const productConfigurations = useProductConfigurationsFromApiName(apiName);
  return usePricingInfoFromProductConfigurations(productConfigurations);
};